import React from "react";
import Style from "./LandingPage.module.css";
import { ReactComponent as AppStore } from "../../../../assets/svg/app_store.svg";
import { ReactComponent as GooglePlay } from "../../../../assets/svg/google_play.svg";
import { ReactComponent as VHCLogo } from "../../../../assets/svg/vhc-logo.svg";
import boschSupergraphic from "../../../../assets/Bosch-Supergraphic_.png";
import logo from "../../../../assets/Bosch_DigitalLogo_BlackAnchor_144x96px.png";
import vhcCarBanner from "../../../../assets/vhc-car-banner.png";
import vhcCarShaddow from "../../../../assets/vhc-car-shaddow.png";
import { Image } from "semantic-ui-react";
import Footer from "../Footer/Footer";

const VHCMobileLandingPage = () => {
  const openMobileStore = (mobileOperationSystem: string): void => {
    let appUrl = "";
    switch (mobileOperationSystem) {
      case "Android":
        appUrl = process.env.REACT_APP_BVHC_MOBILE_APP_CHPLAY_URL || "";
        break;
      case "iOS":
        appUrl = process.env.REACT_APP_BVHC_MOBILE_APP_APPSTORE_URL || "";
        break;
      default:
        break;
    }

    if (appUrl) window.location.href = appUrl;
  };

  return (
    <>
      <div className={Style.vhc_mobile_wrapper}>
        <div className={Style.vhc_mobile_container}>
          <div className={Style.logo}>
            <Image src={logo}></Image>
          </div>
          <div className={Style.supergraphic}>
            <Image src={boschSupergraphic} fluid></Image>
          </div>
          <div className={Style.vhc_banner}>
            <div className={Style.car}>
              <Image src={vhcCarBanner}></Image>
            </div>
            <div className={Style.car_shaddow}>
              <Image src={vhcCarShaddow}></Image>
            </div>
          </div>
          <div className={Style.information}>
            <div className={Style.group_logo}>
              <div className={Style.vhc_logo}>
                <VHCLogo />
              </div>
              <p>Vehicle Health Certificate</p>
            </div>
            <div className={Style.group_download}>
              <p>Download now</p>
              <div className={Style.downloadButton}>
                <AppStore onClick={() => openMobileStore("iOS")} />
                <GooglePlay onClick={() => openMobileStore("Android")} />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
export default VHCMobileLandingPage;
